module.exports = __webpack_public_path__ + "static/media/DM-Negative-Clip-5.f01d3bef.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Negative-Clip-5.mp3
// module id = 135
// module chunks = 0